/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { BreakpointsSizes } from '../../@types/design-system/break-boints';
import Theme from '../../design-system/Theme';

const newTheme = new Theme();
const { mobile, tablet } = newTheme.breakpoints;

const sideFullTablet = css`
  overflow-x: hidden;
`;

const sideFullMobile = css`
  margin: 0 auto;
`;

export const Container = styled.div`
  ${newTheme.respondTo(mobile as BreakpointsSizes, sideFullMobile)}
  ${newTheme.respondTo(tablet as BreakpointsSizes, sideFullTablet)}

  position: relative;
  padding: 1em 10px 2em 10px;
  display: flex;

  nav {
    display: flex;
  }

  article {
    width: 100%;
    margin: 10px auto;
  }

  header {
    margin-bottom: 10px;
  }
`;
